exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".button--2tfy- {\n\tbackground: transparent;\n\tborder: none;\n\toutline: none;\n\tcolor: #fff;\n\twidth: 100%;\n\tcursor: pointer;\n\theight: 65px;\n}\n\n\t.button--2tfy-:hover {\n\t\tbackground: rgba(255,255,255,0.1);\n\t}\n", ""]);

// Exports
exports.locals = {
	"button": "button--2tfy-"
};